var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#code_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.014 4.751h-3.046V1.286c0-.596-.409-1.148-1.023-1.258-.818-.155-1.523.44-1.523 1.214v3.51H9.65v-3.51c0-.73-.636-1.303-1.41-1.237-.659.066-1.136.64-1.136 1.28v3.466H4.058c-.5 0-.886.375-.886.861v.663c0 .486.386.86.886.86h.227v.64c0 .884.182 1.745.523 2.518l.568-.729c.364-.485.932-.75 1.545-.75a1.96 1.96 0 0 1 1.478.662c.364.42.523.95.432 1.5l-.318 2.054h.318c.659 0 1.295.286 1.66.817.476.684.453 1.545-.046 2.186L9.4 17.4v3.003c0 .33.273.596.614.596h2.045a.603.603 0 0 0 .614-.596v-6.292a6.87 6.87 0 0 0 3.137-1.7c1.227-1.192 1.978-2.826 1.978-4.636v-.64h.227c.5 0 .886-.375.886-.861v-.663c0-.463-.41-.86-.886-.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 14.2H7.08l.545-3.421c.114-.707-.84-1.104-1.273-.508L2.24 15.658a.689.689 0 0 0 .568 1.103h1.796l-.545 3.422c-.114.706.84 1.104 1.273.508l4.114-5.387c.364-.441.023-1.104-.546-1.104"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "code_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.1 0h16.8v21H2.1z"
  })))));
};
export default SvgCode;